<div class="container-fluid">
  <div class="row no-gutters">
    <!-- Left Section -->
    <div class="col-md-6 left-section">
      <div class="logo-container">
        <ul class="d-flex" style="list-style: none;">
          <li> <img src="../../assets/images/grammarin-logo/grammarin-logo.svg"  alt="logo-main" class="img-fluid"
              class="logo"></li>
        </ul>
      </div>
      <div class="login-form">
        <h3 style="font-size: 28px ; font-weight: 600;">Reset Password</h3>
        <p class="mt-2 p" style="line-height: 24px">Please create a new password that. You don't use an any other site.
        </p> 
        <span
        class="alert alert-danger mb-2" id="dangerAlert" style="display: none; "></span>
        <span *ngIf="esubText3" class="alert alert-danger mb-2" id="dangerAlerts" style="width: 374px"
          [ngStyle]="{ color: color }">
          <i class="fa fa-times-circle" style="margin-right: 3px;"></i>
          {{ dangerAlerts }}</span>
        <form method="" action="" class="mb-0 " [formGroup]="register">


          <div class="form-group">
            <div class="input-group mb-2  bd-light">
              <div class="input-group-prepend">
                <div class="input-group-text bg-white border-0" style="padding-left: 15px">
                  <img class="img-fluid" src="../../assets/images/signin-signup/lock.svg" alt="password" width="18" />
                </div>
              </div>

              <label for="pass_log_id5" class="d-none">ss</label>

              <input id="pass_log_id7" type="password" class="form-control border-0" value="password"
                name="login_password" formControlName="password" placeholder="Password" onfocus="this.placeholder=''"
                onblur="this.placeholder='Password'" required minlength="8" class="form-control border-0"
                name="login_password" placeholder="Password" />
              <span class="fa fa-fw fa-eye field_icon toggle-password7"
                style="color: #000000; float: right; margin-bottom: -30px;   padding-left: 18px;   margin-top: 14px;  margin-right: 30px;"></span>
            </div>
          </div>
          <div class="form-group">
            <div class="input-group mb-2  bd-light">
              <div class="input-group-prepend">
                <div class="input-group-text bg-white border-0" style="padding-left: 15px"> <img class="img-fluid"
                    src="../../assets/images/signin-signup/lock.svg" alt="password" width="18" /> </div>
              </div>
              <label for="pass_log_id5" class="d-none">ss</label>
              <input id="pass_log_id8" value="password" name="login_password" formControlName="confirmPassword"
                type="password" onfocus="this.placeholder=''" onblur="this.placeholder='Confirm new Password'"
                minlength="8" class="form-control border-0" name="login_password" placeholder="Confirm new Password"
                required /> <span class="fa fa-fw fa-eye field_icon toggle-password8"
                style="color: #000000; float: right; margin-bottom: -30px;   padding-left: 18px;   margin-top: 14px;  margin-right: 30px;"></span>
            </div>
          </div>
          <div id="recaptcha-container"  data-size="compact" data-theme="light" style="display: flex; justify-content: center;  margin-top: 15px;"></div>
          <div class="form-group row mb-0">
            <div class="col-12 text-left pt-1">
              <button [ngClass]="{'.btn-dark:not(:disabled):not(.disabled):active': esubText3}" type="submit"
                class="btn btn-dark rounded m-0 px-0 w-100" (click)="handleButtonClick($event)"> Update </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Right Section -->
    <div class="col-md-6 right-section">
      <div class="marginSection">
        <h4>Reset Password</h4>
       
        <p>To continue staying connected with us, please reset your password using your email address.</p> <img
        src="../../assets/images/editorimages/editor-new-logo.png" alt="Illustration" class="IllustrationImage img-fluid" />
      </div>
    </div>
  </div>
